import type { CalculatedTaskStatus } from '@lmc/ts-common'
import type { TaskFiltersValue } from '../components/TaskFilters'

export type AllFilters = TaskFiltersValue & {
  search?: string
  sortOrder?: '-1' | '1'
}

export const convertPropsToParams = (
  props:
    | Pick<
        AllFilters,
        | 'categories'
        | 'residents'
        | 'categoryItems'
        | 'status'
        | 'rangePicker'
        | 'search'
      >
    | undefined
) => ({
  categories: props?.categories,
  from: props?.rangePicker?.[0]?.startOf('day').toISOString(),
  items: props?.categoryItems,
  residents: props?.residents,
  status: props?.status as CalculatedTaskStatus[],
  title: props?.search,
  to: props?.rangePicker?.[1]?.endOf('day').toISOString()
})
